import type { CountryInfo } from "@shared/schema";

const current = {
  currentWaitTime: "Current",
  priorityDate: "Current",
  trend: "stable" as const,
};

export const countries: CountryInfo[] = [
  {
    code: "CN",
    name: "China",
    nativeName: "中国",
    flag: "🇨🇳",
    language: "zh",
    eb5Stats: {
      currentWaitTime: "~10 years for unreserved",
      priorityDate: "August 15, 2016",
      trend: "improving",
    },
  },
  {
    code: "IN",
    name: "India",
    nativeName: "भारत",
    flag: "🇮🇳",
    language: "hi",
    eb5Stats: {
      currentWaitTime: "~4 years for unreserved",
      priorityDate: "May 1, 2022",
      trend: "improving",
    },
  },
  {
    code: "AF",
    name: "Afghanistan",
    nativeName: "افغانستان",
    flag: "🇦🇫",
    language: "ps",
    eb5Stats: current,
  },
  {
    code: "AL",
    name: "Albania",
    nativeName: "Shqipëria",
    flag: "🇦🇱",
    language: "sq",
    eb5Stats: current,
  },
  {
    code: "DZ",
    name: "Algeria",
    nativeName: "الجزائر",
    flag: "🇩🇿",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "AD",
    name: "Andorra",
    nativeName: "Andorra",
    flag: "🇦🇩",
    language: "ca",
    eb5Stats: current,
  },
  {
    code: "AO",
    name: "Angola",
    nativeName: "Angola",
    flag: "🇦🇴",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "AG",
    name: "Antigua and Barbuda",
    nativeName: "Antigua and Barbuda",
    flag: "🇦🇬",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "AR",
    name: "Argentina",
    nativeName: "Argentina",
    flag: "🇦🇷",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "AM",
    name: "Armenia",
    nativeName: "Հայաստան",
    flag: "🇦🇲",
    language: "hy",
    eb5Stats: current,
  },
  {
    code: "AU",
    name: "Australia",
    nativeName: "Australia",
    flag: "🇦🇺",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "AT",
    name: "Austria",
    nativeName: "Österreich",
    flag: "🇦🇹",
    language: "de",
    eb5Stats: current,
  },
  {
    code: "AZ",
    name: "Azerbaijan",
    nativeName: "Azərbaycan",
    flag: "🇦🇿",
    language: "az",
    eb5Stats: current,
  },
  {
    code: "BS",
    name: "Bahamas",
    nativeName: "Bahamas",
    flag: "🇧🇸",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "BH",
    name: "Bahrain",
    nativeName: "البحرين",
    flag: "🇧🇭",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "BD",
    name: "Bangladesh",
    nativeName: "বাংলাদেশ",
    flag: "🇧🇩",
    language: "bn",
    eb5Stats: current,
  },
  {
    code: "BB",
    name: "Barbados",
    nativeName: "Barbados",
    flag: "🇧🇧",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "BY",
    name: "Belarus",
    nativeName: "Беларусь",
    flag: "🇧🇾",
    language: "be",
    eb5Stats: current,
  },
  {
    code: "BE",
    name: "Belgium",
    nativeName: "België",
    flag: "🇧🇪",
    language: "nl",
    eb5Stats: current,
  },
  {
    code: "BZ",
    name: "Belize",
    nativeName: "Belize",
    flag: "🇧🇿",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "BJ",
    name: "Benin",
    nativeName: "Bénin",
    flag: "🇧🇯",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "BT",
    name: "Bhutan",
    nativeName: "འབྲུག",
    flag: "🇧🇹",
    language: "dz",
    eb5Stats: current,
  },
  {
    code: "BO",
    name: "Bolivia",
    nativeName: "Bolivia",
    flag: "🇧🇴",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    nativeName: "Bosna i Hercegovina",
    flag: "🇧🇦",
    language: "bs",
    eb5Stats: current,
  },
  {
    code: "BW",
    name: "Botswana",
    nativeName: "Botswana",
    flag: "🇧🇼",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "BR",
    name: "Brazil",
    nativeName: "Brasil",
    flag: "🇧🇷",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "BN",
    name: "Brunei",
    nativeName: "بروني",
    flag: "🇧🇳",
    language: "ms",
    eb5Stats: current,
  },
  {
    code: "BG",
    name: "Bulgaria",
    nativeName: "България",
    flag: "🇧🇬",
    language: "bg",
    eb5Stats: current,
  },
  {
    code: "BF",
    name: "Burkina Faso",
    nativeName: "Burkina Faso",
    flag: "🇧🇫",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "BI",
    name: "Burundi",
    nativeName: "Burundi",
    flag: "🇧🇮",
    language: "rn",
    eb5Stats: current,
  },
  {
    code: "CV",
    name: "Cabo Verde",
    nativeName: "Cabo Verde",
    flag: "🇨🇻",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "KH",
    name: "Cambodia",
    nativeName: "កម្ពុជា",
    flag: "🇰🇭",
    language: "km",
    eb5Stats: current,
  },
  {
    code: "CM",
    name: "Cameroon",
    nativeName: "Cameroun",
    flag: "🇨🇲",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "CA",
    name: "Canada",
    nativeName: "Canada",
    flag: "🇨🇦",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "CF",
    name: "Central African Republic",
    nativeName: "République centrafricaine",
    flag: "🇨🇫",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "TD",
    name: "Chad",
    nativeName: "تشاد",
    flag: "🇹🇩",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "CL",
    name: "Chile",
    nativeName: "Chile",
    flag: "🇨🇱",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "CO",
    name: "Colombia",
    nativeName: "Colombia",
    flag: "🇨🇴",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "KM",
    name: "Comoros",
    nativeName: "جزر القمر",
    flag: "🇰🇲",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "CD",
    name: "Congo (DRC)",
    nativeName: "République démocratique du Congo",
    flag: "🇨🇩",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "CG",
    name: "Congo (Republic)",
    nativeName: "République du Congo",
    flag: "🇨🇬",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "CR",
    name: "Costa Rica",
    nativeName: "Costa Rica",
    flag: "🇨🇷",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "CI",
    name: "Côte d'Ivoire",
    nativeName: "Côte d'Ivoire",
    flag: "🇨🇮",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "HR",
    name: "Croatia",
    nativeName: "Hrvatska",
    flag: "🇭🇷",
    language: "hr",
    eb5Stats: current,
  },
  {
    code: "CU",
    name: "Cuba",
    nativeName: "Cuba",
    flag: "🇨🇺",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "CY",
    name: "Cyprus",
    nativeName: "Κύπρος",
    flag: "🇨🇾",
    language: "el",
    eb5Stats: current,
  },
  {
    code: "CZ",
    name: "Czech Republic",
    nativeName: "Česko",
    flag: "🇨🇿",
    language: "cs",
    eb5Stats: current,
  },
  {
    code: "DK",
    name: "Denmark",
    nativeName: "Danmark",
    flag: "🇩🇰",
    language: "da",
    eb5Stats: current,
  },
  {
    code: "DJ",
    name: "Djibouti",
    nativeName: "جيبوتي",
    flag: "🇩🇯",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "DM",
    name: "Dominica",
    nativeName: "Dominica",
    flag: "🇩🇲",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "DO",
    name: "Dominican Republic",
    nativeName: "República Dominicana",
    flag: "🇩🇴",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "EC",
    name: "Ecuador",
    nativeName: "Ecuador",
    flag: "🇪🇨",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "EG",
    name: "Egypt",
    nativeName: "مصر",
    flag: "🇪🇬",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "SV",
    name: "El Salvador",
    nativeName: "El Salvador",
    flag: "🇸🇻",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "GQ",
    name: "Equatorial Guinea",
    nativeName: "Guinea Ecuatorial",
    flag: "🇬🇶",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "ER",
    name: "Eritrea",
    nativeName: "ኤርትራ",
    flag: "🇪🇷",
    language: "ti",
    eb5Stats: current,
  },
  {
    code: "EE",
    name: "Estonia",
    nativeName: "Eesti",
    flag: "🇪🇪",
    language: "et",
    eb5Stats: current,
  },
  {
    code: "SZ",
    name: "Eswatini",
    nativeName: "eSwatini",
    flag: "🇸🇿",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "ET",
    name: "Ethiopia",
    nativeName: "ኢትዮጵያ",
    flag: "🇪🇹",
    language: "am",
    eb5Stats: current,
  },
  {
    code: "FJ",
    name: "Fiji",
    nativeName: "Fiji",
    flag: "🇫🇯",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "FI",
    name: "Finland",
    nativeName: "Suomi",
    flag: "🇫🇮",
    language: "fi",
    eb5Stats: current,
  },
  {
    code: "FR",
    name: "France",
    nativeName: "France",
    flag: "🇫🇷",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "GA",
    name: "Gabon",
    nativeName: "Gabon",
    flag: "🇬🇦",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "GM",
    name: "Gambia",
    nativeName: "Gambia",
    flag: "🇬🇲",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "GE",
    name: "Georgia",
    nativeName: "საქართველო",
    flag: "🇬🇪",
    language: "ka",
    eb5Stats: current,
  },
  {
    code: "DE",
    name: "Germany",
    nativeName: "Deutschland",
    flag: "🇩🇪",
    language: "de",
    eb5Stats: current,
  },
  {
    code: "GH",
    name: "Ghana",
    nativeName: "Ghana",
    flag: "🇬🇭",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "GR",
    name: "Greece",
    nativeName: "Ελλάδα",
    flag: "🇬🇷",
    language: "el",
    eb5Stats: current,
  },
  {
    code: "GD",
    name: "Grenada",
    nativeName: "Grenada",
    flag: "🇬🇩",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "GT",
    name: "Guatemala",
    nativeName: "Guatemala",
    flag: "🇬🇹",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "GN",
    name: "Guinea",
    nativeName: "Guinée",
    flag: "🇬🇳",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "GW",
    name: "Guinea-Bissau",
    nativeName: "Guiné-Bissau",
    flag: "🇬🇼",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "GY",
    name: "Guyana",
    nativeName: "Guyana",
    flag: "🇬🇾",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "HT",
    name: "Haiti",
    nativeName: "Haïti",
    flag: "🇭🇹",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "HN",
    name: "Honduras",
    nativeName: "Honduras",
    flag: "🇭🇳",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "HK",
    name: "Hong Kong",
    nativeName: "香港",
    flag: "🇭🇰",
    language: "zh-HK",
    eb5Stats: current,
  },
  {
    code: "HU",
    name: "Hungary",
    nativeName: "Magyarország",
    flag: "🇭🇺",
    language: "hu",
    eb5Stats: current,
  },
  {
    code: "IS",
    name: "Iceland",
    nativeName: "Ísland",
    flag: "🇮🇸",
    language: "is",
    eb5Stats: current,
  },
  {
    code: "ID",
    name: "Indonesia",
    nativeName: "Indonesia",
    flag: "🇮🇩",
    language: "id",
    eb5Stats: current,
  },
  {
    code: "IR",
    name: "Iran",
    nativeName: "ایران",
    flag: "🇮🇷",
    language: "fa",
    eb5Stats: current,
  },
  {
    code: "IQ",
    name: "Iraq",
    nativeName: "العراق",
    flag: "🇮🇶",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "IE",
    name: "Ireland",
    nativeName: "Éire",
    flag: "🇮🇪",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "IL",
    name: "Israel",
    nativeName: "ישראל",
    flag: "🇮🇱",
    language: "he",
    eb5Stats: current,
  },
  {
    code: "IT",
    name: "Italy",
    nativeName: "Italia",
    flag: "🇮🇹",
    language: "it",
    eb5Stats: current,
  },
  {
    code: "JM",
    name: "Jamaica",
    nativeName: "Jamaica",
    flag: "🇯🇲",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "JP",
    name: "Japan",
    nativeName: "日本",
    flag: "🇯🇵",
    language: "ja",
    eb5Stats: current,
  },
  {
    code: "JO",
    name: "Jordan",
    nativeName: "الأردن",
    flag: "🇯🇴",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "KZ",
    name: "Kazakhstan",
    nativeName: "Қазақстан",
    flag: "🇰🇿",
    language: "kk",
    eb5Stats: current,
  },
  {
    code: "KE",
    name: "Kenya",
    nativeName: "Kenya",
    flag: "🇰🇪",
    language: "sw",
    eb5Stats: current,
  },
  {
    code: "KI",
    name: "Kiribati",
    nativeName: "Kiribati",
    flag: "🇰🇮",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "XK",
    name: "Kosovo",
    nativeName: "Kosova",
    flag: "🇽🇰",
    language: "sq",
    eb5Stats: current,
  },
  {
    code: "KW",
    name: "Kuwait",
    nativeName: "الكويت",
    flag: "🇰🇼",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "KG",
    name: "Kyrgyzstan",
    nativeName: "Кыргызстан",
    flag: "🇰🇬",
    language: "ky",
    eb5Stats: current,
  },
  {
    code: "LA",
    name: "Laos",
    nativeName: "ລາວ",
    flag: "🇱🇦",
    language: "lo",
    eb5Stats: current,
  },
  {
    code: "LV",
    name: "Latvia",
    nativeName: "Latvija",
    flag: "🇱🇻",
    language: "lv",
    eb5Stats: current,
  },
  {
    code: "LB",
    name: "Lebanon",
    nativeName: "لبنان",
    flag: "🇱🇧",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "LS",
    name: "Lesotho",
    nativeName: "Lesotho",
    flag: "🇱🇸",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "LR",
    name: "Liberia",
    nativeName: "Liberia",
    flag: "🇱🇷",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "LY",
    name: "Libya",
    nativeName: "ليبيا",
    flag: "🇱🇾",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "LI",
    name: "Liechtenstein",
    nativeName: "Liechtenstein",
    flag: "🇱🇮",
    language: "de",
    eb5Stats: current,
  },
  {
    code: "LT",
    name: "Lithuania",
    nativeName: "Lietuva",
    flag: "🇱🇹",
    language: "lt",
    eb5Stats: current,
  },
  {
    code: "LU",
    name: "Luxembourg",
    nativeName: "Lëtzebuerg",
    flag: "🇱🇺",
    language: "lb",
    eb5Stats: current,
  },
  {
    code: "MG",
    name: "Madagascar",
    nativeName: "Madagasikara",
    flag: "🇲🇬",
    language: "mg",
    eb5Stats: current,
  },
  {
    code: "MW",
    name: "Malawi",
    nativeName: "Malawi",
    flag: "🇲🇼",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "MY",
    name: "Malaysia",
    nativeName: "Malaysia",
    flag: "🇲🇾",
    language: "ms",
    eb5Stats: current,
  },
  {
    code: "MV",
    name: "Maldives",
    nativeName: "ދިވެހިރާއްޖެ",
    flag: "🇲🇻",
    language: "dv",
    eb5Stats: current,
  },
  {
    code: "ML",
    name: "Mali",
    nativeName: "Mali",
    flag: "🇲🇱",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "MT",
    name: "Malta",
    nativeName: "Malta",
    flag: "🇲🇹",
    language: "mt",
    eb5Stats: current,
  },
  {
    code: "MH",
    name: "Marshall Islands",
    nativeName: "Marshall Islands",
    flag: "🇲🇭",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "MR",
    name: "Mauritania",
    nativeName: "موريتانيا",
    flag: "🇲🇷",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "MU",
    name: "Mauritius",
    nativeName: "Maurice",
    flag: "🇲🇺",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "MX",
    name: "Mexico",
    nativeName: "México",
    flag: "🇲🇽",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "FM",
    name: "Micronesia",
    nativeName: "Micronesia",
    flag: "🇫🇲",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "MD",
    name: "Moldova",
    nativeName: "Moldova",
    flag: "🇲🇩",
    language: "ro",
    eb5Stats: current,
  },
  {
    code: "MC",
    name: "Monaco",
    nativeName: "Monaco",
    flag: "🇲🇨",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "MN",
    name: "Mongolia",
    nativeName: "Монгол",
    flag: "🇲🇳",
    language: "mn",
    eb5Stats: current,
  },
  {
    code: "ME",
    name: "Montenegro",
    nativeName: "Crna Gora",
    flag: "🇲🇪",
    language: "sr",
    eb5Stats: current,
  },
  {
    code: "MA",
    name: "Morocco",
    nativeName: "المغرب",
    flag: "🇲🇦",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "MZ",
    name: "Mozambique",
    nativeName: "Moçambique",
    flag: "🇲🇿",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "MM",
    name: "Myanmar",
    nativeName: "မြန်မာ",
    flag: "🇲🇲",
    language: "my",
    eb5Stats: current,
  },
  {
    code: "NA",
    name: "Namibia",
    nativeName: "Namibia",
    flag: "🇳🇦",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "NR",
    name: "Nauru",
    nativeName: "Nauru",
    flag: "🇳🇷",
    language: "na",
    eb5Stats: current,
  },
  {
    code: "NP",
    name: "Nepal",
    nativeName: "नेपाल",
    flag: "🇳🇵",
    language: "ne",
    eb5Stats: current,
  },
  {
    code: "NL",
    name: "Netherlands",
    nativeName: "Nederland",
    flag: "🇳🇱",
    language: "nl",
    eb5Stats: current,
  },
  {
    code: "NZ",
    name: "New Zealand",
    nativeName: "Aotearoa",
    flag: "🇳🇿",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "NI",
    name: "Nicaragua",
    nativeName: "Nicaragua",
    flag: "🇳🇮",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "NE",
    name: "Niger",
    nativeName: "Niger",
    flag: "🇳🇪",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "NG",
    name: "Nigeria",
    nativeName: "Nigeria",
    flag: "🇳🇬",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "KP",
    name: "North Korea",
    nativeName: "조선",
    flag: "🇰🇵",
    language: "ko",
    eb5Stats: current,
  },
  {
    code: "MK",
    name: "North Macedonia",
    nativeName: "Северна Македонија",
    flag: "🇲🇰",
    language: "mk",
    eb5Stats: current,
  },
  {
    code: "NO",
    name: "Norway",
    nativeName: "Norge",
    flag: "🇳🇴",
    language: "no",
    eb5Stats: current,
  },
  {
    code: "OM",
    name: "Oman",
    nativeName: "عُمان",
    flag: "🇴🇲",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "PK",
    name: "Pakistan",
    nativeName: "پاکستان",
    flag: "🇵🇰",
    language: "ur",
    eb5Stats: current,
  },
  {
    code: "PW",
    name: "Palau",
    nativeName: "Palau",
    flag: "🇵🇼",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "PS",
    name: "Palestine",
    nativeName: "فلسطين",
    flag: "🇵🇸",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "PA",
    name: "Panama",
    nativeName: "Panamá",
    flag: "🇵🇦",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "PG",
    name: "Papua New Guinea",
    nativeName: "Papua New Guinea",
    flag: "🇵🇬",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "PY",
    name: "Paraguay",
    nativeName: "Paraguay",
    flag: "🇵🇾",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "PE",
    name: "Peru",
    nativeName: "Perú",
    flag: "🇵🇪",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "PH",
    name: "Philippines",
    nativeName: "Pilipinas",
    flag: "🇵🇭",
    language: "tl",
    eb5Stats: current,
  },
  {
    code: "PL",
    name: "Poland",
    nativeName: "Polska",
    flag: "🇵🇱",
    language: "pl",
    eb5Stats: current,
  },
  {
    code: "PT",
    name: "Portugal",
    nativeName: "Portugal",
    flag: "🇵🇹",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "QA",
    name: "Qatar",
    nativeName: "قطر",
    flag: "🇶🇦",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "RO",
    name: "Romania",
    nativeName: "România",
    flag: "🇷🇴",
    language: "ro",
    eb5Stats: current,
  },
  {
    code: "RU",
    name: "Russia",
    nativeName: "Россия",
    flag: "🇷🇺",
    language: "ru",
    eb5Stats: current,
  },
  {
    code: "RW",
    name: "Rwanda",
    nativeName: "Rwanda",
    flag: "🇷🇼",
    language: "rw",
    eb5Stats: current,
  },
  {
    code: "KN",
    name: "Saint Kitts and Nevis",
    nativeName: "Saint Kitts and Nevis",
    flag: "🇰🇳",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "LC",
    name: "Saint Lucia",
    nativeName: "Saint Lucia",
    flag: "🇱🇨",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "VC",
    name: "Saint Vincent and the Grenadines",
    nativeName: "Saint Vincent and the Grenadines",
    flag: "🇻🇨",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "WS",
    name: "Samoa",
    nativeName: "Samoa",
    flag: "🇼🇸",
    language: "sm",
    eb5Stats: current,
  },
  {
    code: "SM",
    name: "San Marino",
    nativeName: "San Marino",
    flag: "🇸🇲",
    language: "it",
    eb5Stats: current,
  },
  {
    code: "ST",
    name: "Sao Tome and Principe",
    nativeName: "São Tomé e Príncipe",
    flag: "🇸🇹",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "SA",
    name: "Saudi Arabia",
    nativeName: "المملكة العربية السعودية",
    flag: "🇸🇦",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "SN",
    name: "Senegal",
    nativeName: "Sénégal",
    flag: "🇸🇳",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "RS",
    name: "Serbia",
    nativeName: "Србија",
    flag: "🇷🇸",
    language: "sr",
    eb5Stats: current,
  },
  {
    code: "SC",
    name: "Seychelles",
    nativeName: "Seychelles",
    flag: "🇸🇨",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "SL",
    name: "Sierra Leone",
    nativeName: "Sierra Leone",
    flag: "🇸🇱",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "SG",
    name: "Singapore",
    nativeName: "Singapore",
    flag: "🇸🇬",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "SK",
    name: "Slovakia",
    nativeName: "Slovensko",
    flag: "🇸🇰",
    language: "sk",
    eb5Stats: current,
  },
  {
    code: "SI",
    name: "Slovenia",
    nativeName: "Slovenija",
    flag: "🇸🇮",
    language: "sl",
    eb5Stats: current,
  },
  {
    code: "SB",
    name: "Solomon Islands",
    nativeName: "Solomon Islands",
    flag: "🇸🇧",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "SO",
    name: "Somalia",
    nativeName: "Soomaaliya",
    flag: "🇸🇴",
    language: "so",
    eb5Stats: current,
  },
  {
    code: "ZA",
    name: "South Africa",
    nativeName: "South Africa",
    flag: "🇿🇦",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "KR",
    name: "South Korea",
    nativeName: "대한민국",
    flag: "🇰🇷",
    language: "ko",
    eb5Stats: current,
  },
  {
    code: "SS",
    name: "South Sudan",
    nativeName: "South Sudan",
    flag: "🇸🇸",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "ES",
    name: "Spain",
    nativeName: "España",
    flag: "🇪🇸",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "LK",
    name: "Sri Lanka",
    nativeName: "ශ්‍රී ලංකා",
    flag: "🇱🇰",
    language: "si",
    eb5Stats: current,
  },
  {
    code: "SD",
    name: "Sudan",
    nativeName: "السودان",
    flag: "🇸🇩",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "SR",
    name: "Suriname",
    nativeName: "Suriname",
    flag: "🇸🇷",
    language: "nl",
    eb5Stats: current,
  },
  {
    code: "SE",
    name: "Sweden",
    nativeName: "Sverige",
    flag: "🇸🇪",
    language: "sv",
    eb5Stats: current,
  },
  {
    code: "CH",
    name: "Switzerland",
    nativeName: "Schweiz",
    flag: "🇨🇭",
    language: "de",
    eb5Stats: current,
  },
  {
    code: "SY",
    name: "Syria",
    nativeName: "سوريا",
    flag: "🇸🇾",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "TW",
    name: "Taiwan",
    nativeName: "台灣",
    flag: "🇹🇼",
    language: "zh-TW",
    eb5Stats: current,
  },
  {
    code: "TJ",
    name: "Tajikistan",
    nativeName: "Тоҷикистон",
    flag: "🇹🇯",
    language: "tg",
    eb5Stats: current,
  },
  {
    code: "TZ",
    name: "Tanzania",
    nativeName: "Tanzania",
    flag: "🇹🇿",
    language: "sw",
    eb5Stats: current,
  },
  {
    code: "TH",
    name: "Thailand",
    nativeName: "ประเทศไทย",
    flag: "🇹🇭",
    language: "th",
    eb5Stats: current,
  },
  {
    code: "TL",
    name: "Timor-Leste",
    nativeName: "Timor-Leste",
    flag: "🇹🇱",
    language: "pt",
    eb5Stats: current,
  },
  {
    code: "TG",
    name: "Togo",
    nativeName: "Togo",
    flag: "🇹🇬",
    language: "fr",
    eb5Stats: current,
  },
  {
    code: "TO",
    name: "Tonga",
    nativeName: "Tonga",
    flag: "🇹🇴",
    language: "to",
    eb5Stats: current,
  },
  {
    code: "TT",
    name: "Trinidad and Tobago",
    nativeName: "Trinidad and Tobago",
    flag: "🇹🇹",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "TN",
    name: "Tunisia",
    nativeName: "تونس",
    flag: "🇹🇳",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "TR",
    name: "Turkey",
    nativeName: "Türkiye",
    flag: "🇹🇷",
    language: "tr",
    eb5Stats: current,
  },
  {
    code: "TM",
    name: "Turkmenistan",
    nativeName: "Türkmenistan",
    flag: "🇹🇲",
    language: "tk",
    eb5Stats: current,
  },
  {
    code: "TV",
    name: "Tuvalu",
    nativeName: "Tuvalu",
    flag: "🇹🇻",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "UG",
    name: "Uganda",
    nativeName: "Uganda",
    flag: "🇺🇬",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "UA",
    name: "Ukraine",
    nativeName: "Україна",
    flag: "🇺🇦",
    language: "uk",
    eb5Stats: current,
  },
  {
    code: "AE",
    name: "UAE",
    nativeName: "الإمارات",
    flag: "🇦🇪",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "GB",
    name: "United Kingdom",
    nativeName: "United Kingdom",
    flag: "🇬🇧",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "UY",
    name: "Uruguay",
    nativeName: "Uruguay",
    flag: "🇺🇾",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "UZ",
    name: "Uzbekistan",
    nativeName: "Ўзбекистон",
    flag: "🇺🇿",
    language: "uz",
    eb5Stats: current,
  },
  {
    code: "VU",
    name: "Vanuatu",
    nativeName: "Vanuatu",
    flag: "🇻🇺",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "VA",
    name: "Vatican City",
    nativeName: "Città del Vaticano",
    flag: "🇻🇦",
    language: "it",
    eb5Stats: current,
  },
  {
    code: "VE",
    name: "Venezuela",
    nativeName: "Venezuela",
    flag: "🇻🇪",
    language: "es",
    eb5Stats: current,
  },
  {
    code: "VN",
    name: "Vietnam",
    nativeName: "Việt Nam",
    flag: "🇻🇳",
    language: "vi",
    eb5Stats: current,
  },
  {
    code: "YE",
    name: "Yemen",
    nativeName: "اليمن",
    flag: "🇾🇪",
    language: "ar",
    eb5Stats: current,
  },
  {
    code: "ZM",
    name: "Zambia",
    nativeName: "Zambia",
    flag: "🇿🇲",
    language: "en",
    eb5Stats: current,
  },
  {
    code: "ZW",
    name: "Zimbabwe",
    nativeName: "Zimbabwe",
    flag: "🇿🇼",
    language: "en",
    eb5Stats: current,
  },
];

export const getCountryByCode = (code: string) =>
  countries.find((c) => c.code.toLowerCase() === code.toLowerCase());
